import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
const EventArea = React.lazy(() => import('./EventArea'))
const path = location.pathname.replace(/\/$/, '')

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {path === '/events' ? (
      <React.Suspense fallback={<p>Loading…</p>}>
        <EventArea />
      </React.Suspense>
    ) : (
      <App />
    )}
  </React.StrictMode>,
)
